import { NavigateFunction } from 'react-router-dom';
import { QueryStringSet } from 'utilities/constants';

export const numericSort = (items: any, key: string, sortType = 'asc') => {
  return items.sort((a: any, b: any) => {
    if (sortType === 'asc') {
      return Number(a[key]) - Number(b[key]);
    } else {
      return Number(b[key]) - Number(a[key]);
    }
  });
};

export const alphaSort = (data: any[], key: string) => {
  return data.sort((a, b) => {
    /* istanbul ignore else */
    if (a[key] < b[key]) {
      return -1;
    }
    /* istanbul ignore else */
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
};

export const getStringByReplaceAllSpaceWithDash = (
  replacingString: string,
  doNotConvertToLowerCase?: boolean
) => {
  const replacingStr = doNotConvertToLowerCase
    ? replacingString?.trim()
    : replacingString?.trim()?.toLowerCase();
  return replacingStr ? replacingStr.replaceAll(' ', '-') : '';
};

export const getParsedJSONObject = (jsonData: any) => {
  try {
    if (jsonData) {
      if (typeof jsonData === 'object') return jsonData;
      const parsedJSONObject = JSON.parse(jsonData);
      /* istanbul ignore else */
      if (parsedJSONObject && typeof parsedJSONObject === 'object') {
        return parsedJSONObject;
      }
    }
    return {};
  } catch (e) {
    return {};
  }
};

export const shuffleArrayElements = ([...array]: any[]) => {
  /* istanbul ignore else */
  if (array && array.length > 0) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }
  return array;
};

export const isValidURL = (link: string) => {
  if (link) {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' + // validate protocol
        '([a-z\\d.-]+\\.[a-z]{2,}|' + // validate domain name
        '(\\d{1,3}\\.){3}\\d{1,3})' + // validate OR ip (v4) address
        '(\\:\\d+)?' + // validate port
        '(\\/[^\\s]*)*' + // validate path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
        '(\\#[-a-z\\d_]*)?$', // validate fragment locator
      'i'
    );
    return urlPattern.test(link);
  } else {
    return false;
  }
};

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getPercentageScore = (
  baseValue: number,
  totalValue: number,
  doRoundedUp?: boolean
) => {
  const percentageScore: number = (baseValue / totalValue) * 100;
  return doRoundedUp ? Math.ceil(percentageScore) : percentageScore;
};

export const getUserInitials = (userName: string) => {
  return userName
    ?.split(' ')
    ?.map((n) => n[0])
    ?.slice(0, 2)
    ?.join('');
};

export const isArrayObject = <T>(arr: T[]) => {
  return arr?.every((item) => typeof item === 'object');
};

export const getTopNavigationTabPath = (path: string): string => {
  return path?.split('/')?.slice(0, 2)?.join('/');
};

export const areStringsEqual = (str1: string, str2: string) => {
  return str1.toLowerCase() === str2.toLowerCase();
};

export const getQueryStringForHomeSummaryNavigation = () => {
  return `?${QueryStringSet?.paramName?.access}=${QueryStringSet?.paramValue?.fromHome}`;
};

export const navigateToPageFromHome = (
  path: string,
  navigate: NavigateFunction
) => {
  if (navigate) navigate(`${path}${getQueryStringForHomeSummaryNavigation()}`);
};

export const scrollToPageTop = (
  topPosition?: number,
  scrollBehavior?: ScrollBehavior
) => {
  window.scrollTo({
    top: topPosition ?? 0,
    behavior: scrollBehavior ?? 'smooth',
  });
};

export const scrollEventListener = (eventListenerCallaback: EventListener) => {
  window.addEventListener('scroll', eventListenerCallaback);
  return () => window.removeEventListener('scroll', eventListenerCallaback);
};

interface IGetEmployeeFullName {
  firstName?: string;
  middleName?: string;
  lastName?: string;
}

export const getEmployeeFullName = ({
  firstName,
  middleName,
  lastName,
}: IGetEmployeeFullName): string => {
  return [firstName, middleName, lastName].filter(Boolean).join(' ');
};

export const getEmployeeInitials = ({
  firstName,
  middleName,
  lastName,
}: IGetEmployeeFullName): string => {
  return [firstName?.[0], middleName?.[0], lastName?.[0]]
    .filter(Boolean)
    .join('');
};
